// Creates a new promise that automatically resolves after some timeout:
Promise.delay = function (time) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, time)
    })
}

// Throttle this promise to resolve no faster than the specified time:
Promise.prototype.takeAtLeast = function (time) {
    return new Promise((resolve, reject) => {
        Promise.all([this, Promise.delay(time)]).then(([result]) => {
            resolve(result)
        }, reject)
    })
}

// Cleanse Integers and Floats, strips all non-numbers (except decimals)
Number.prototype.cleanseInteger = function (value) {
    const formatted = value == undefined ? '' : value.toString().replace(/[^\d.-]/g, '');
    return parseInt(formatted);
}

Number.prototype.cleanseFloat = function (value, precision = 2) {
    const stripped = value == undefined ? '' : value.toString().replace(/[^\d.-]/g, '');
    const formatted = parseFloat(stripped).toFixed(precision);
    return parseFloat(formatted);
}

Number.prototype.isFloat = function (value) {
    return Number(value) === value && value % 1 !== 0;
}


/*  PMT Calculation
    * pv     - present value  ( i.e. 40.00 TI $ to Amort. )
    * ir     - interest rate per month ( i.e. 6 for 6% )
    * months - number of periods (months)  ( i.e. 120 for 10 year term )
*/
Number.prototype.pmt = function (pv, ir, months) {
    pv = parseFloat(pv);
    ir = parseFloat(parseInt(ir) / 1200);
    months = parseInt(months); 

    if (ir > 0) {
        return (ir * -pv * Math.pow((1 + ir), months)) / ((1 - Math.pow((1 + ir), months)));
    }

    return pv / months;
}

// Import formatters and make them available globally
import { formatCompactNumber } from './utils/formatters';
import Vue from 'vue';

// Add formatCompactNumber to Vue prototype for global access
Vue.prototype.$formatCompactNumber = formatCompactNumber;